import { green, primary } from '~styles/colors';

export const primaryGradient = {
  // 190: `linear-gradient(45deg, ${primary['100']}, ${green['100']})`,
  // 175: `linear-gradient(45deg, ${primary['100']}, ${green['100']})`,
  // 150: `linear-gradient(45deg, ${primary['100']}, ${green['100']})`,
  // 125: `linear-gradient(45deg, ${primary['100']}, ${green['100']})`,
  100: `linear-gradient(45deg, ${primary['100']}, ${green['100']})`,
  75: `linear-gradient(45deg, ${primary['75']}, ${green['75']})`,
  50: `linear-gradient(45deg, ${primary['50']}, ${green['50']})`,
  25: `linear-gradient(45deg, ${primary['25']}, ${green['25']})`,
  10: `linear-gradient(45deg, ${primary['10']}, ${green['10']})`,
};

export type PrimaryGradientVariants = keyof typeof primaryGradient;
